<button mat-icon-button [matMenuTriggerFor]="menu">
  <mat-icon svgIcon="more_vert"></mat-icon>
</button>
<mat-menu #menu="matMenu">
  <ng-template matMenuContent>
    <a
      mat-menu-item
      type="button"
      [dialogLink]="['tasks', task().id, 'sessions', sessionIndex(), 'edit']"
      data-e2e="menu-session__button-edit"
    >
      Edit
    </a>
    <a
      mat-menu-item
      type="button"
      [dialogLink]="['tasks', task().id, 'sessions', sessionIndex(), 'split']"
      data-e2e="menu-session__button-split"
      [disabled]="isSplitDisabled()"
    >
      Split
    </a>
    <button mat-menu-item type="button" (click)="remove()" data-e2e="menu-session__button-delete">Delete</button>
    <a
      mat-menu-item
      type="button"
      routerLink="."
      [queryParams]="skipAfterParams"
      queryParamsHandling="merge"
      data-e2e="menu-session__button-skip-after"
      >Skip everything after</a
    >
    <a
      mat-menu-item
      type="button"
      routerLink="."
      [queryParams]="skipBeforeParams"
      queryParamsHandling="merge"
      data-e2e="menu-session__button-skip-before"
      >Skip everything before</a
    >
  </ng-template>
</mat-menu>
